export default __webpack_public_path__ + "static/GT-Super-Display-Bold-98b112fbb63487e7fda968397bf0f48e.woff";